import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputChipsCst from "@components/InputCst/InpuctChipsCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";

const AgendaSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
}) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: theme.palette.text.primary,
          }}
        >
          {t("sections.agenda.title")}
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: theme.palette.text.primary,
            mt: 0.5,
          }}
        >
          {t("sections.agenda.description")}
        </Typography>
      </Box>
      <InputChipsCst
        id="activity-agenda"
        label={t("content.class.agenda") || ""}
        value={data.agenda as unknown as []}
        onAdd={(chips: string[]) => setData({ agenda: chips })}
        maxLength={25}
      />
    </Box>
  );
};

export default AgendaSection;
